<template>
  <!-- 新增商品分类 -->
  <div class="addProClassify">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <!-- 表单容器 -->
    <el-scrollbar style="height:calc(100% - 60px);padding-top:20px;box-sizing:border-box;">
      <el-form :model="addForm" label-position="rigth" label-width="100px"
        :rules="addFormRule" ref="addForm">
        <div class="form-item-wrap">
          <el-form-item label="父类别" prop="parent">
            <el-select v-model="addForm.parent" placeholder="请选择" clearable style="width:200px">
              <el-option label="一级路径" value=""></el-option>
              <el-option 
                v-for="(item,index) in classifyList" 
                :key="index"
                :label="item.label" 
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input v-model="addForm.sort" clearable style="width:200px"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="类别名称" prop="name">
            <el-input v-model="addForm.name" clearable style="width:200px"></el-input>
          </el-form-item>
          <el-form-item label="调用别名" prop="alias">
            <el-input v-model="addForm.alias" clearable style="width:200px"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="seo标题" prop="seoTit">
            <el-input v-model="addForm.seoTit" clearable style="width:200px"></el-input>
          </el-form-item>
          <el-form-item label="seo描述" prop="seoDes">
            <el-input v-model="addForm.seoDes" clearable style="width:200px"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="分类图片" prop="">
            <!-- 图片预览组件 -->
            <img-view :imgList="[{url:classImg,id:0}]">
            </img-view>
            <!-- 文件上传组件 -->
            <upload @fileChange="imgFallback" 
              accept="image/jpg,image/jpeg,image/png">
            </upload>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="" prop="">
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button type="info" @click="resetForm">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: 'addProClassify',
  data() {
    return {
      /**分类表单 */
      addForm:{
        id: "", // 分类ID
        grade: "1", // 分类等级
        parent:"", // 分类父级ID
        sort:"1", // 排序值
        name:"", // 分类名称
        img:"", // 分类图片
        alias:"", // 调用别名
        seoTit:"", // seo标题
        seoDes:"" // seo描述
      },
      addFormRule:{
        sort: [mustFill],
        name: [mustFill],
      },
      classifyList:[],/**分类列表 */
      // 存放分类图片临时位置
      classImg: ''
    }
  },
  mounted(){
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if (prams) {
      //执行编辑
      this.getClassInfo(prams.id)
      if(prams.grade == 2){
        this.getClassify()
      }
    }else{
      this.getClassify()
    }
  },
  methods:{
    /**返回上一页 */
    goBack() {
      this.$router.go(-1);
      this.$destroy()
    },
    // 获取分类详情
    getClassInfo(id){
      let data = {
        type: "GetGoodsCategory_detail",
        id: id
      };
      let proc = "Proc_Admin_Category";//存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url: "goods/ashx/ReturnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + proc,
        method:"post",
      }).then((res) => {
        if(res.flag == 0){
          this.addForm.id = res.data[0].id
          this.addForm.grade = res.data[0].class_layer
          this.addForm.parent = res.data[0].parent_id
          this.addForm.sort = res.data[0].sort_id
          this.addForm.name = res.data[0].title
          this.addForm.img = res.data[0].img_url
          this.classImg = this.$setImgUrl(res.data[0].img_url)
          this.addForm.alias = res.data[0].call_index
          this.addForm.seoTit = res.data[0].seo_title
          this.addForm.seoDes = res.data[0].content
          if(res.data[0].class_layer == 1){
            this.addForm.parent = ''
          }
        }
      }).catch((err) => {
        window.console.log(err);
      });
    },

    /**图片成功上传回调 */
    imgFallback(file){
      if (file.length) {
        //将上传的图片file对象直接转化为blob地址，无需重新获取商品详情
        this.classImg = URL.createObjectURL(file[0])
        let fileData = new FormData();
        for (let i = 0; i < file.length; i++) {
          fileData.append('Categorysfile', file[i]);
        }
        let type = 'categorys'
        this.$uploadRequest({
          url: "admin/ashx/UploadImg.ashx?type=UploadImage&imgType=" + type,
          method: "post",
          data: fileData
        }).then((res) => {
          if(res.flag == 0){
            this.addForm.img = res.message
            this.$message({
              message: '图片上传成功',
              type: 'success'
            });
          }else{
            this.$message({
              message: res.message,
              type: 'error'
            });
          }
        }).catch((err) => {
          window.console.log(err);
        });
      }
    },
    /**获取一级分类 */
    getClassify(){
      let data = {
        type: "GetGoodsCategory_yj"
      };
      let proc = "Proc_Admin_Category";//存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url: "goods/ashx/ReturnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + proc,
        method:"post",
      }).then((res) => {
        this.classifyList = [];
        if (res.flag == 0) {
          res.data.forEach(item => {
            this.classifyList.push({
              label: item.title,
              value: item.id
            })
          });
        }
      }).catch((err) => {
        window.console.log(err);
      });
    },

    /**提交表单 */
    submitForm(){
      this.$refs['addForm'].validate((valid)=>{
        if (valid) {
          if(!this.addForm.id){
            if(this.addForm.parent){
              this.addForm.grade = '2'
            }else{
              this.addForm.grade = '1'
            }
          }
          let data = {
            type: "SaveGoodsCategory",
            class_layer: this.addForm.grade,
            parent_id: this.addForm.parent,
            sort_id: this.addForm.sort,
            title: this.addForm.name,
            call_index: this.addForm.alias,
            seo_title: this.addForm.seoTit,
            content: this.addForm.seoDes,
            img_url: this.addForm.img,
            id: this.addForm.id
          };
          let proc = "Proc_Admin_Category";//存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url: "goods/ashx/ReturnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + proc,
            method:"post",
          }).then((res) => {
            if (res.flag == 0) {
              //提示新增功能成功,关闭dialog,刷新数据
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.goBack();//返回上一页会自动重置表单
            } else {
              //失败提示
              this.$message({
                message: res.message,
                type: 'error'
              });
            }
          }).catch((err) => {
            window.console.log(err);
          });
        } else {
          this.$message({
            message: '请补全信息',
            type: 'warning'
          });
        }
      })
    },
    /**重置表单 */
    resetForm(){
      this.$refs['addForm'].resetFields();
    },
  }
}
</script>

<style scoped>
.addProClassify{
  width: 100%;
  height: 100%;
}
</style>
